import React from 'react';
import styles from './LinkButton.module.scss';

export interface ILinkButton {
  id: string;
  ariaLabel?: string;
  children: React.ReactNode;
  href: string;
  mode?: 'primary' | 'secondary' | 'tertiary';
  target?: '_self' | '_blank' | '_parent' | '_top';
}

export default function LinkButton({
  id,
  ariaLabel,
  children,
  href,
  mode = 'primary',
  target = '_self',
}: ILinkButton) {
  const modeClassName =
    mode === 'primary' ? styles.primary : mode === 'secondary' ? styles.secondary : styles.tertiary;

  return (
    <a
      id={id}
      aria-label={ariaLabel}
      href={href}
      target={target}
      className={[styles.linkButton, modeClassName].join(' ')}
      referrerPolicy="same-origin"
      rel="noopener"
    >
      {children}
    </a>
  );
}
